import React from 'react';
import { StyledButton } from './styled';
import { NativeButtonProps } from 'antd/lib/button/button';

const Button = ({ type = 'primary', ...rest }: NativeButtonProps) => {
  return <StyledButton type={type} {...rest} />;
};

export default Button;
